"use client";
import { jsx as p } from "react/jsx-runtime";
import { cn as t } from "../../../utils/cn.js";
import { forwardRef as l, memo as f } from "react";
const o = l(
  ({ className: a, children: r, ...e }, m) => /* @__PURE__ */ p(
    "div",
    {
      ref: m,
      className: t("gap-popup-gap flex flex-col", a),
      ...e,
      children: r
    }
  )
);
o.displayName = "ModalFooter";
const i = f(o);
export {
  o as ModalFooter,
  i as default
};
